import { render } from "./modaleComposition.vue?vue&type=template&id=64f6c53d"
import script from "./modaleComposition.vue?vue&type=script&lang=js"
export * from "./modaleComposition.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__